module.exports = __webpack_public_path__ + "static/media/tax.d4b42ddd.jpg";